import { ButtonGroup, ButtonOption, Column, Text } from '@amzn/meridian';
import { kebabCase } from 'es-toolkit/compat';
import { type FC, useMemo } from 'react';
import { type AllGroups, GroupLabels } from './filters.util';

export type SummaryFilterProps = {
  groupList: string[];
  groupedBy: string | null;
  possibleGroupingsMap: {
    [groupType: string]: boolean;
  };
  onClear: () => void;
  setGroupBy: (groupType: string) => void;
};

export const SummaryFilter: FC<SummaryFilterProps> = ({ groupList, groupedBy, possibleGroupingsMap, onClear, setGroupBy }) => {
  const filteredGroups = useMemo(
    () => groupList.filter((groupType: string): boolean => possibleGroupingsMap[groupType]),
    [
      groupList,
      possibleGroupingsMap,
    ],
  );

  const buttonGroupValue = useMemo(
    () => (groupedBy ? groupedBy : 'all'),
    [
      groupedBy,
    ],
  );

  return (
    <Column spacing="200">
      <Text type="b200">View by</Text>
      <ButtonGroup size="small" type="outline" value={buttonGroupValue}>
        <ButtonOption data-cy="view-by-all" key="all" onClick={onClear} value="all">
          All
        </ButtonOption>
        {filteredGroups.map((group) => (
          <ButtonOption data-cy={`view-by-${kebabCase(group)}`} key={group} onClick={() => setGroupBy(group)} value={group}>
            {GroupLabels[group as AllGroups]}
          </ButtonOption>
        ))}
      </ButtonGroup>
    </Column>
  );
};
